import React, { useState } from 'react';

const LocationForm = ({ getSearchBarLocation, getDropDownZoom, ...props }) => {

  const [newCenter, setNewCenter] = useState("");
  const [dropDownDistance, setDropDownDistance] = useState("");

  const handleSubmit = (event) => {  // handle the submit of the geocoding input box
    event.preventDefault();
    getSearchBarLocation(newCenter + " USA");
    setNewCenter(""); // reset the form value after submission
  };

  const handleDropDownChange = (e) => {   // handle the change of the zoop drop down menu
    const zoom = e;
    setDropDownDistance(e);
    getDropDownZoom(zoom);
  };

  return (
    <div className="store-locator-header">
      <h1 className="store-locator-header-text">Find Your Store</h1>
      <form className="store-locator-header-search-form" onSubmit={handleSubmit}>
        <div className="store-locator-header-search-form-control-buttons">
          <input
            type="text"
            id="newCenter"
            name="newCenter"
            className="search-form-input"
            placeholder="ZIP Code, City, or State"
            value={newCenter}
            onChange={(e) => setNewCenter(e.target.value)} />
          <div className="store-locator-header-search-form-submit-container">
            <button className="search-form-submit" type="submit">
              {/* <i className="fas fa-search"></i> */}
              <p>Look Up</p>
            </button>
          </div>
        </div>
      </form>

      {/* <div className="distance-dropdown">
        <div className="distance-dropdown-container">
          <label for="miles">Distance:</label>

          <select name="miles" value={dropDownDistance} onChange={(e) => handleDropDownChange(e.target.value)} id="miles">
            <option value="10">50 miles</option>
            <option value="11">25 miles</option>
            <option value="12">15 miles</option>
            <option value="13">10 miles</option>
            <option value="14">5 miles</option>

          </select>
        </div>
      </div> */}
    </div>
  );
}

export default LocationForm;